'use client';
import React from 'react';
import ButtonBox from '../../button/ButtonBox.mjs';
import ButtonBoxDouble from '../../button/ButtonBoxDouble.mjs';
import { BUTTON_BOX_SIZE } from '../../../constants/button.mjs';
import { useBottomModalNotice } from '../../../contexts/ModalContext.mjs';

function BottomModalNoticeButton(_ref) {
  let {
    oneButton,
    twoButton
  } = _ref;
  const {
    close
  } = useBottomModalNotice();
  // One Button Props
  if (oneButton) {
    return /*#__PURE__*/React.createElement(ButtonBox, {
      ...oneButton,
      size: BUTTON_BOX_SIZE.LARGE_FULL,
      onClick: oneButton.onClick ?? close
    });
  }
  // Two Button Type
  if (twoButton) {
    const {
      ratio,
      leftButton,
      rightButton
    } = twoButton;
    return /*#__PURE__*/React.createElement(ButtonBoxDouble, {
      size: BUTTON_BOX_SIZE.LARGE,
      ratio: ratio,
      leftButton: {
        ...leftButton,
        onClick: leftButton.onClick ?? close
      },
      rightButton: {
        ...rightButton,
        onClick: rightButton.onClick ?? close
      }
    });
  }
  return null;
}

export { BottomModalNoticeButton as default };
